export default "__VITE_ASSET__DMvrDtpD__"